import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
  VmiFrmMantenedorAlertasComponent
} from './views/administracion/vmi-frm-mantenedor-alertas/vmi-frm-mantenedor-alertas.component';
import {
  VmiFrmMantenedorAmortiguadorComponent
} from './views/administracion/vmi-frm-mantenedor-amortiguador/vmi-frm-mantenedor-amortiguador.component';
import {
  VmiFrmMantenedorArticulosComponent
} from './views/administracion/vmi-frm-mantenedor-articulos/vmi-frm-mantenedor-articulos.component';
import {
  VmiFrmMantenedorClientesComponent
} from './views/administracion/vmi-frm-mantenedor-clientes/vmi-frm-mantenedor-clientes.component';
import {
  VmiFrmMantenedorColorPorcentajeComponent
} from './views/administracion/vmi-frm-mantenedor-color-porcentaje/vmi-frm-mantenedor-color-porcentaje.component';
import {
  VmiFrmMantenedorRefrescamientoTanquesComponent
} from './views/administracion/vmi-frm-mantenedor-refrescamiento-tanques/vmi-frm-mantenedor-refrescamiento-tanques.component';
import {
  VmiFrmMantenedorReporteDiarioComponent
} from './views/administracion/vmi-frm-mantenedor-reporte-diario/vmi-frm-mantenedor-reporte-diario.component';
import {
  VmiFrmMantenedorTanquesComponent
} from './views/administracion/vmi-frm-mantenedor-tanques/vmi-frm-mantenedor-tanques.component';
import {
  VmiFrmMantenedorUsuariosComponent
} from './views/administracion/vmi-frm-mantenedor-usuarios/vmi-frm-mantenedor-usuarios.component';
import {
  VmiReporteEstadoProductoComponent
} from './views/informes/vmi-reporte-estado-producto/vmi-reporte-estado-producto.component';
import {
  VmiReportePenetracionComponent
} from './views/informes/vmi-reporte-penetracion/vmi-reporte-penetracion.component';
import {VmiHomeComponent} from './views/vmi-home/vmi-home.component';
import { VmiFrmMantenedorPedidosComponent } from './views/administracion/vmi-frm-mantenedor-pedidos/vmi-frm-mantenedor-pedidos.component';
import { VmiReportePenetracionClasicoComponent } from './views/informes/vmi-reporte-penetracion-clasico/vmi-reporte-penetracion-clasico.component';
import { VmiReporteSegumientoComponent } from './views/informes/vmi-reporte-seguimiento/vmi-reporte-seguimiento.component';
import { VmiFrmMantenedorIntegradorComponent } from './views/administracion/vmi-frm-mantenedor-integador/vmi-frm-mantenedor-integrador.component';

const vmiRoutes: Routes = [
  //* PANTALLA PRINCIPAL HOME
  {path: 'vmi/home', component: VmiHomeComponent},

  //*PANTALLAS DE ADMINISTRACION MANTENEDORES
  {path: 'vmi/administracion/mantenedor-articulos', component: VmiFrmMantenedorArticulosComponent},
  {path: 'vmi/administracion/mantenedor-amortiguador', component: VmiFrmMantenedorAmortiguadorComponent},
  {path: 'vmi/administracion/mantenedor-tanques', component: VmiFrmMantenedorTanquesComponent},
  {path: 'vmi/administracion/mantenedor-clientes', component: VmiFrmMantenedorClientesComponent},
  {path: 'vmi/administracion/mantenedor-color-porcentaje', component: VmiFrmMantenedorColorPorcentajeComponent},
  {path: 'vmi/administracion/mantenedor-usuarios', component: VmiFrmMantenedorUsuariosComponent},
  {path: 'vmi/administracion/mantenedor-alertas', component: VmiFrmMantenedorAlertasComponent},
  {path: 'vmi/administracion/mantenedor-reporte-diario', component: VmiFrmMantenedorReporteDiarioComponent},
  {path: 'vmi/administracion/mantenedor-usuarios-integracion', component: VmiFrmMantenedorIntegradorComponent},
  {
    path: 'vmi/administracion/mantenedor-refrescamiento-tanque',
    component: VmiFrmMantenedorRefrescamientoTanquesComponent
  },

  //*
  {path: 'vmi/informes/reporte-penetracion', component: VmiReportePenetracionComponent},
  {path: 'vmi/informes/reporte-penetracion-classic', component: VmiReportePenetracionClasicoComponent},
  {path: 'vmi/informes/reporte-estado-producto', component: VmiReporteEstadoProductoComponent},
  {path: 'vmi/informes/reporte-seguimiento', component: VmiReporteSegumientoComponent},
  {path: 'vmi/administracion/mantenedor-pedidos', component: VmiFrmMantenedorPedidosComponent}
];

@NgModule({
  imports: [RouterModule.forChild(vmiRoutes)],
  exports: [RouterModule]
})
export class vmiRoutingModule {
}

//*APLICACION => VMI
//*ROL => ROLE_VMI_ADMIN
//*AUTHORITY => ROLE_VMI_ADMIN

